export default (value, rule) => value.toString().length > 0;



// WEBPACK FOOTER //
// ./src/utils/validate/methods/required.js